import React from "react";
import { observer } from "mobx-react-lite";
import { useRootStore } from "../../../../store/contexts";
import { ErrorDialog } from "../../../../common/controls";
import { ShowcaseLineListStore } from "../../store/ShowcaseLineListStore";

type ShowcaseLineListDialogsProps = {
  store: ShowcaseLineListStore;
};

/**
 * Componente que agrupa todos los dialogs del listado de ShowcaseLine.
 * Separado para mantener ShowcaseLineListPage más limpio.
 */
export const ShowcaseLineListDialogs: React.FC<ShowcaseLineListDialogsProps> =
  observer(({ store }) => {
    const { langStore } = useRootStore();

    return (
      <>
        {/* Dialog de error genérico */}
        <ErrorDialog
          open={store.errorDialogOpened}
          title={store.errorTitle || langStore.errorTitle}
          description={store.errorDescription}
          onClose={() => store.closeErrorDialog()}
        />
      </>
    );
  });
